import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {
  ROLE_PUT,
  ROLE_DELETE,
  ROLE_GET,
  ROLE_POST,
  ROLE_GET_MODULE_COMPONENTS,
} from '../endpoints/role.endpoints';

import { Role, RoleModule } from 'src/app/admin/admin.models';

import { catchError, Observable, throwError } from 'rxjs';

// TODO: We will pass typized objects to the services containing all inputs
@Injectable({ providedIn: 'root' })
export class RoleApiService {
  private readonly http = inject(HttpClient);

  getRole(roleId: string): Observable<Role> {
    return this.http.get<Role>(ROLE_GET(roleId)).pipe(
      catchError((error) => {
        // Silent on purpose (WAP-1857): rethrown to the caller's handler.
        console.error('Error fetching role', error);
        return throwError(error);
      }),
    );
  }

  getModuleComponents(): Observable<RoleModule[]> {
    return this.http.get<RoleModule[]>(ROLE_GET_MODULE_COMPONENTS);
  }

  saveRole(role: Role): Observable<Role> {
    return this.http.post<Role>(ROLE_POST(role.id), role);
  }

  deleteRole(roleId: string): Observable<void> {
    return this.http.delete<void>(ROLE_DELETE(roleId));
  }

  createRole(role: Role): Observable<Role> {
    return this.http.put<Role>(ROLE_PUT, role);
  }
}
